import type { SvgIconProps } from "@mui/material/SvgIcon";
import SvgIcon from "@mui/material/SvgIcon";

export type WaterlyIconProps = SvgIconProps;

const WaterlyIcon = (props: WaterlyIconProps) => {
  return (
    <SvgIcon {...props} inheritViewBox>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <g fillRule="evenodd">
          <path
            fill="inherit"
            d="M12 2c-2.76 6.68-6.62 8.34-6.62 13.38a6.62 6.62 0 1 0 13.24 0c0-5.02-3.86-6.7-6.62-13.38Z"
          />
          <path
            fill="#fff"
            d="M8.78 18.08a.56.56 0 0 1-.47-.25 4.5 4.5 0 0 1-.72-2.45 6.41 6.41 0 0 1 1.49-3.98.54.54 0 0 1 .76-.13.56.56 0 0 1 .14.77 5.4 5.4 0 0 0-1.3 3.32 3.37 3.37 0 0 0 .55 1.84.56.56 0 0 1-.15.78.59.59 0 0 1-.3.08z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};

export default WaterlyIcon;
